import Icon from '../components/Icon.vue'

Icon.register({
  ambulance: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M624 352c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-48c0 53-43 96-96 96s-96-43-96-96h-128c0 53-43 96-96 96s-96-43-96-96h-16c-26.5 0-48-21.5-48-48v-320c0-26.5 21.5-48 48-48h320c26.5 0 48 21.5 48 48v48h44.1c12.7 0 24.9 5.1 33.9 14.1l99.9 99.9c9 9 14.1 21.2 14.1 33.9v108.1h16zM160 464c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zM304 216v-48c0-4.4-3.6-8-8-8h-56v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56h-56c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h56v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h56c4.4 0 8-3.6 8-8zM480 464c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zM560 256v-12.1l-99.9-99.9h-44.1v112h144z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ambulance.js
// module id = 596
// module chunks = 0